import rolesService from '../services/roles';
import useAsyncList from './useAsyncList';

/**
 * All roles of an app (flag roles included; split them with utils/roleFlags.splitRoles).
 * @param {string} appId
 * @param {string} [tenantId] scope to a tenant's roles plus application roles
 * @param {{ enabled?: boolean }} [opts]
 * @returns {{ items: object[], byId: Record<string, object>, loading: boolean, error: string, reload: () => void }}
 */
export default function useRoles(appId, tenantId, { enabled = true } = {}) {
    return useAsyncList(() => rolesService.getAll(appId, tenantId), {
        key: appId ? `${appId}|${tenantId || ''}` : '',
        enabled,
        idKey: 'role_id',
        errorMessage: 'Couldn’t load roles for this app.',
    });
}
